import { Service } from "@angular/core";
import {
    NiceAdvancedFiltersIcons,
    NiceAdvancedFiltersIconsService
} from "@recursyve/nice-filter-view/advanced-filters";

const filterGroups = ["agent", "event", "user"] as const;
type FilterGroups = (typeof filterGroups)[number];

@Service()
export class AdvancedFilterIconsService extends NiceAdvancedFiltersIconsService<FilterGroups> {
    public override getFilterGroupIcon(group: FilterGroups): NiceAdvancedFiltersIcons | null {
        if (!filterGroups.includes(group)) {
            return null;
        }

        return { svgIcon: this.getFilterIconName(group) };
    }

    private getFilterIconName(group: FilterGroups): string {
        switch (group) {
            case "event":
                return "streamline-regular:calendar";
            case "agent":
                return "streamline-regular:single-neutral-1";
            case "user":
                return "streamline-regular:single-neutral-1";
        }
    }
}
